import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DefaultDataService, HttpUrlGenerator } from '@ngrx/data';
import { KE_SCHEDULES_PRESETS_ENTITY_NAME } from '@selfai-platform/store';
import { map, Observable } from 'rxjs';
import { WorkflowPresets } from '../../workflow-presets';
import { WorkflowPresetsApiService } from '@selfai-platform/pipeline-api';

@Injectable({
  providedIn: 'root',
})
export class SchedulesPresetsListDataService extends DefaultDataService<WorkflowPresets> {
  constructor(
    public override http: HttpClient,
    public override httpUrlGenerator: HttpUrlGenerator,
    private readonly schedulesPresetsListApiService: WorkflowPresetsApiService,
  ) {
    super(KE_SCHEDULES_PRESETS_ENTITY_NAME, http, httpUrlGenerator);
  }

  override getAll(): Observable<WorkflowPresets[]> {
    return this.schedulesPresetsListApiService
      .getAllPresets()
      .pipe(map((items) => items.map((item) => ({ ...item, name: item.name }))));
  }
}
